import styled from 'styled-components';
import { px2rem, getSpace } from '@stylesheets/tools';
import { fontFamilies } from '../../../../stylesheets/settings';

const StyledEducationRefinementHits = styled.div`
  .hits__grid {
    display: flex;
    flex-direction: column;
    gap: ${px2rem('10px')};
  }
  .hits__load-more {
    display: flex;
    justify-content: center;
    margin-top: ${getSpace('xl')};

    .hits__load-more-button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: ${px2rem('10px')};
      color: black;

      span {
        font-family: ${fontFamilies.default};
        font-size: ${px2rem('20px')};
      }
      svg {
        height: ${px2rem('24px')};
        width: ${px2rem('24px')};
      }
    }
  }
  .hits__not-found {
    padding-top: ${getSpace('l')};
    text-align: center;

    .hits__not-found-title {
      display: block;
      font-size: ${px2rem('24px')};
      margin-bottom: ${px2rem('10px')};
    }
  }
`;

export default StyledEducationRefinementHits;
